import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { Layout } from '../components/Layout';
import { Seo } from '../components/Seo';
import { WeekendFinder } from '../components/WeekendFinder';
import { AffiliateDisclosure } from '../components/AffiliateDisclosure';
import { Sparkles } from 'lucide-react';

export default function FlightWeekends() {
  const [params] = useSearchParams();
  const originCode = params.get('origin');
  const initial = originCode ? {
    originCode: originCode.toUpperCase(),
    destCode: params.get('destination') ? params.get('destination').toUpperCase() : null,
    anywhere: params.get('anywhere') === '1',
    month: params.get('month') || undefined,
    longWeekend: params.get('long') === '1',
  } : undefined;
  return (
    <Layout>
      <Seo title="Weekend Finder — Cheapest Fri–Sun Getaways" path="/flights/weekends"
        description="Find the cheapest Friday–Sunday round trips for any month with FlightDeals.in Weekend Finder. Pick a destination or discover the cheapest weekend escape from your city." />
      <section className="relative">
        <div className="absolute inset-0 h-56 sm:h-64">
          <img src="https://images.unsplash.com/photo-1507525428034-b723cf961d3e?w=1400&q=80" alt="" className="w-full h-full object-cover" />
          <div className="absolute inset-0 hero-overlay" />
        </div>
        <div className="relative max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 pt-12 sm:pt-14 pb-6">
          <span className="inline-flex items-center gap-1.5 text-xs font-semibold uppercase tracking-wide text-accent-foreground/90 bg-accent/30 px-3 py-1 rounded-full mb-3">
            <Sparkles className="h-3.5 w-3.5" /> Weekend Finder
          </span>
          <h1 className="font-display text-3xl sm:text-4xl font-semibold text-primary-foreground">Escape any weekend</h1>
          <p className="text-primary-foreground/80 mt-1 max-w-2xl">Pick a month and we'll surface the cheapest Friday–Sunday round trips — or discover the cheapest weekend escape from your city.</p>
        </div>
      </section>

      <section className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
        <WeekendFinder variant="page" initial={initial} syncUrl />
        <div className="mt-4"><AffiliateDisclosure variant="footer" /></div>
      </section>
    </Layout>
  );
}
